import { RootState } from "@/vuex/types";
import { GetterTree } from "vuex";
import { AccountState } from "./account.types";

type AccountGetter = GetterTree<AccountState, RootState>;

export const getters: AccountGetter = {
  loading(state: AccountState): boolean {
    return state.loading;
  },

  accountData(state: AccountState): any {
    return state.accountData;
  },

  loadingAvailability(state: AccountState): boolean {
    return state.loadingAvailability;
  },

  availability(state: AccountState): any {
    return state.availability;
  }
};
